module.exports = __webpack_public_path__ + "img/oie-aaa-logo.png";